import { useContext } from 'react'
import {
  AGE_ACQUISITION_CLICKED_ON_DESTINATION_PAGE_MAP,
  AGE_ACQUISITION_CLICKED_ON_THEME_PAGE_MAP,
  OPTIMIZELY_VARIANT_KEYS,
} from 'src/constants'
import { GlobalProps } from 'src/utils/globalProps'
import { useSpecificOptimizelyUserDecision } from '../optimizely-for-client'

export function useShowThumbnailMap(): boolean {
  const { pageType } = useContext(GlobalProps)

  const decision = useSpecificOptimizelyUserDecision(
    pageType === 'Destination'
      ? AGE_ACQUISITION_CLICKED_ON_DESTINATION_PAGE_MAP
      : AGE_ACQUISITION_CLICKED_ON_THEME_PAGE_MAP,
    ['Destination', 'Theme'].includes(pageType),
  )

  return (
    (pageType === 'Destination' &&
      decision?.variationKey ===
        OPTIMIZELY_VARIANT_KEYS.CLICKED_ON_DESTINATION_PAGE_MAP) ||
    (pageType === 'Theme' &&
      decision?.variationKey ===
        OPTIMIZELY_VARIANT_KEYS.CLICKED_ON_THEME_PAGE_MAP)
  )
}
